import React from "react";
import { Page } from "../../components/page/page";
import styles from "./energy.module.css";
import { ChooseButton } from "../../components/choose-button/choose-button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setEnergy } from "../../store/stateSlice";

const options = [
  {
    value: "Always, I'm very sensitive to it",
    icon: "😌",
  },
  {
    value: "I notice it if I’m paying attention",
    icon: "🧐",
  },
  {
    value: "It's not something I usually notice",
    icon: "🤨",
  },
  {
    value: "Not sure",
    icon: "🤔",
  },
];

const EnergyPage = () => {
  const dispatch = useDispatch();
  return (
    <Page
      title="Do you sense the energy of a room when you enter?"
      hideContinueButton={true}
      currentStep={3}
    >
      <ul className={styles.list}>
        {options.map((option, i) => (
          <li key={i}>
            <Link
              to="../crowd-comfort"
              onClick={() => dispatch(setEnergy(option.value))}
            >
              <ChooseButton icon={option.icon}>{option.value}</ChooseButton>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export { EnergyPage };
